<template>
    <div v-if="buttonInitiated" :class="[isCampaignDonate() ? 'custom-btn-donate':'custom-btn-default']">
        <div id="custom_btn_txt" v-if="!detailController.isLoading && isShowCustomText" v-html="customLbl"></div>
        <div v-if="isCampaignDonate()" id="quantity_row">
            <div id="quantity_input_wrapper">
                <div class="quantity-icon">
                    <img src="@/assets/icon/ic-plus-circle-new.svg"
                        @click="changeQty('plus')" />
                </div>
                <div id="quantity_input">
                    <div class="input-wrapper">
                        <InputDonate :max="redeemLimit" v-model="selectQuantity"></InputDonate>
                    </div>
                </div>
                <div class="quantity-icon">
                    <img v-if="selectQuantity == 1" src="@/assets/icon/ic-minus-circle-enable.svg" />
                    <img v-else src="@/assets/icon/ic-minus-circle-new.svg" @click="changeQty('minus')" />
                </div>
            </div>
        </div>
        <div id="btn">
            <div id="redeem_btn" class="btn-wrapper"
                :class="[{'btn-disable': isButtonDisable}, buttonClass]"
                v-if="!detailController.isLoading">
                <div class="btn-txt"
                    v-html="buttonLbl"
                    @click="clickRedeem"></div>
            </div>
            <div class="btn-wrapper btn-disable"
                v-if="detailController.isLoading">
                <div class="btn-txt"
                    @click="clickRedeem">{{lblRedeemBTN.isLoading}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";
//helper
import { TrackingService } from "@/helper/TrackingHelper.js";
import InputDonate from "../../../../components/Input/InputDonate.vue";
/**
 * Property
 * @property {boolean} isLogin (required) Is user logged in.
 * @property {number} point (required) User available point.
 * @property {number} selectedPoint (required) Point amount for redeem campaign.
 * @property {number} selectedQuantity (required) Campaign's quantity.
 * @property {object} lblRedeemBTN (required) Text for component.
 * @property {object} campaign (required) Campaign data.
 * @property {object} redeemBTN (required) Redeem information (redeemable, isDisable etc.).
 *
 * Event
 * @event clickRedeem Callback to parent component when click redeem button.
 * Method
 * @method initialRedeemButton Setup redeem button data (text, redeemable, disable css class, etc.).
 *
 * Utilities
 * @method cleanRedeemButtonLabel Replace \n with <br/>.
 * @method getRedeemButtonClass Get redeem current css class.
 */

export default {
    name: "RedeemButton",
    props: {
        isLogin: Boolean,
        userPoint: Number,

        isShowCart: Boolean,
        lblRedeemBTN: Object,
        modalController: Object,
        detailController: Object,
    },
    components: {
        // ModalMaster,
        InputDonate
    },
    data: function() {
        return {
            type: null,
            point: 0,
            pointType: '',
            quantity: 0,
            campaign: {},
            passcode_category: [],

            buttonClass: 'redeem-disable',
            buttonLbl: '',
            buttonInitiated: false,
            isShowCustomText: false,
            customLbl: '',

            isAllowRedeem: false,
            isUseDefault: false,

            trackingService: new TrackingService(this),
            trackingEventCategory: 'campaigndetail_page',

            selectQuantity: 1
        };
    },
    created: function () {
        this.type = this.detailController.type;
        this.point = this.detailController.point;
        this.pointType = this.detailController.pointType;
        this.quantity = this.detailController.quantity;
        this.campaign = this.detailController.campaign;
        this.passcode_category = this.detailController.passcode_category;

        this.buttonLbl = this.lblRedeemBTN.default;
        //for market place
        if(this.detailController.type == 3) this.buttonLbl = this.lblRedeemBTN.marketplace;

        this.isAllowRedeem = this.campaign.isConditionPass;
        this.isButtonDisable = !this.campaign.isConditionPass;
    },
    mounted: function () {
        this.initialRedeemButton();
        this.buttonClass = this.getRedeemButtonClass();
        this.buttonLbl = this.cleanRedeemButtonLabel();

        this.$nextTick(() => {
            this.buttonInitiated = true;
        });
    },
    computed: {
        redeemLimit: function () {
            return Math.floor(this.userPoint / this.point)
        }
    },
    methods: {
        //Event
        clickRedeem: function () {
            console.log('clickRedeem');
            if (this.isAllowRedeem) {
                if (this.isLogin) {
                    if (this.type == Vue.CampaignType.Buy) {
                        this.$emit('clickAddToCart');
                    } else if (this.type == Vue.CampaignType.Donate) {
                        this.detailController.setSelectedQuantity(this.selectQuantity);
                        this.detailController.clickRedeem();
                        this.trackingService.event(this.trackingEventCategory, 'click_redeem', null, null);
                    } else {
                        this.detailController.clickRedeem();
                        this.trackingService.event(this.trackingEventCategory, 'click_redeem', null, null);
                    }
                    // this.detailController.clickRedeem();
                } else {
                    this.modalController.alertModal
                        .clearText()
                        .setTitle(this.lblRedeemBTN.alert_headline)
                        .setMsg(this.lblRedeemBTN.alert_login_msg)
                        .setBtnOk(this.lblRedeemBTN.alert_ok_btn)
                        .setTag('alert-redeem-btn')
                        .show();

                    this.modalController.alertModal
                        .onClickOk(() => {
                            this.$router.push('/register');
                        });
                }
            }
        },
        //Function
        initialRedeemButton: function () {
            //Check is campaign supported.
            if(this.type == Vue.CampaignType.Bid ||
                this.type == Vue.CampaignType.Event ||
                this.type == Vue.CampaignType.Media) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'redeem-notsupport';
                this.buttonLbl = this.lblRedeemBTN.notSupport;
                return;
            }
            //Check expire date.
            if(this.campaign.currentDate > this.campaign.expireDate) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = 'redeem-expired';
                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
                return;
            }
            //Check sold out.
            if(this.quantity <= 0) {
                this.isAllowRedeem = false;
                this.isButtonDisable = true;
                this.buttonClass = "redeem-soldout";
                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
                return;
            }
            //Do validate when logged in.
            if(this.isLogin) {
                //Check user enough point.
                if(this.point > this.userPoint) {
                    if(this.pointType && this.pointType != 'use') {
                        //Get point, do nothing.
                    } else {
                        if(this.type == Vue.CampaignType.Buy) {
                            this.isAllowRedeem = false;
                            this.isButtonDisable = true;
                            this.buttonClass = 'redeem-notenoughpoint';
                            this.buttonLbl = this.lblRedeemBTN.marketplace;
                            return;

                        } else {
                            this.isAllowRedeem = false;
                            this.isButtonDisable = true;
                            this.buttonClass = 'redeem-notenoughpoint';
                            this.buttonLbl = this.lblRedeemBTN.notEnoughPoint;
                            return;
                        }
                    }
                }
                //Handle common case for custom text.
                if(!this.campaign.isConditionPass) {
                    this.isAllowRedeem = false;
                    this.isButtonDisable = true;
                    //Use api text message.                   
                    if(this.isUseDefault) {
                        this.buttonClass = 'redeem-condition';
                        this.buttonLbl = this.campaign.conditionAlert;
                    } else {
                        switch(this.campaign.conditionAlertId) {
                            case 0:
                                //Should not happening (case 0 means this campaign can be redeem).
                                this.buttonLbl = this.lblnone;
                                break;
                            case 1:
                                //Campaign is soldout.
                                this.buttonClass = "redeem-soldout";
                                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.soldOutBuy : this.lblRedeemBTN.soldOut;
                                break;
                            case 2:
                                //User already redeem to maximun per person.
                                this.buttonClass = "redeem-maxperson";
                                this.buttonLbl = this.lblRedeemBTN.maxPerPerson;
                                break;
                            case 3:
                                //Campaign is on cooldown.
                                this.buttonClass = "redeem-cooldown";
                                this.buttonLbl = this.lblRedeemBTN.redeemCoolDown;
                                break;
                            case 4:
                                //Never see this.
                                this.buttonLbl = this.lblRedeemBTN.exceedBuyPointLimitPerday;
                                break;
                            case 1403:
                                //User cannot redeem due to campaign condition and user level.
                                this.buttonClass = "redeem-eligible";
                                this.buttonLbl = this.lblRedeemBTN.conditionIsInvalid; //Not eligible.
                                break;
                            case 1409:
                                //Campaign is already expire.
                                this.buttonClass = "redeem-expired";
                                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignExpiredBuy : this.lblRedeemBTN.campaignExpired;
                                break;
                            case 1410:
                                //Campaign is not available.
                                this.buttonLbl = this.type == Vue.CampaignType.Buy ? this.lblRedeemBTN.campaignNotAvailableBuy : this.lblRedeemBTN.campaignNotAvailable;
                                break;
                            default:
                                //Other case.
                                this.buttonClass = "redeem-condition";
                                this.buttonLbl = this.campaign.conditionAlert;
                                break;
                        }
                    }
                } else {
                    this.buttonClass = 'redeem-allow';

                    if(this.campaign.customCaption) {
                        this.buttonLbl = this.campaign.customCaption;
                    }

                    var cateArr = this.passcode_category;
                    var cateFiltered = cateArr.filter(val => {
                        return (this.campaign.categoryID == val)
                    });

                    if (cateFiltered.length > 0) {
                        this.buttonLbl = this.lblRedeemBTN.cpfProduct.button;
                        this.isShowCustomText = true;
                        this.customLbl = this.lblRedeemBTN.cpfProduct.text;
                    }
                }
            } else {
                this.buttonClass = 'redeem-allow';

                if(this.campaign.customCaption) {
                    this.buttonLbl = this.campaign.customCaption;
                }
            }

        },
        isCampaignDonate: function() {
            if (this.type == Vue.CampaignType.Donate) {
                return true
            }
        },
        changeQty: function (params) {
            if (params == 'minus') {
                if (this.selectQuantity > 1) {

                    this.selectQuantity -= 1;
                }
            } else {
                if (this.selectQuantity == this.redeemLimit || this.selectQuantity == 99) {
                    return
                }
                this.selectQuantity += 1;
            }
        },
        
        //Utilities
        cleanRedeemButtonLabel: function () {
            return Util.newLineToBr(this.buttonLbl);
        },
        getRedeemButtonClass: function () {
            if(!this.isAllowRedeem)
                return this.buttonClass;

            return 'redeem-allow';
        }
    }

}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/components/Input/baseinput.scss";
.custom-btn-donate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100% !important;
    gap: 8px;

    #quantity_row {
       
        width: 55%;

        #quantity_input_wrapper {
            display: flex;
            align-items: center;
            width: 100%;
        }
    }
    #btn {
        width: 45%;
        #redeem_btn {
            width: 100%;
            .btn-txt {
                padding: 5px 16px;
            }
        }

        #custom_btn_txt{
            color: $red-color;
            font-size: 1.25rem;
            line-height: 1;
            text-align: center;
            padding: 10px 0;
        }
    }
    
}
.custom-btn-default {
    width: 100%;
}
</style>
